import { Box, Button, FormHelperText, TextField } from "@mui/material";
import { useSaveContext } from "ra-core";
import { FC, FormEvent, useEffect, useRef, useState } from "react";
import { useSimpleSaveAction } from "~/controller/SaveContextProvider";
import { rEmail, SimpleFormContextProvider, SrRegion, useLoginContext, useSimpleForm, useSimpleFormContext } from "~/pages/authentication/LoginContext";
import retrieveAxiosErr from "~/utils/retrieveAxiosErr";


const validator = {
  email: (x:string) => {
    if (!x || x === '') { return 'Email is required' }
    if (x.length > 256) { return 'Must not exceed 255 characters' }
    if (!rEmail.test(x)) {
      return 'You must use a valid email address.'
    }
  }
}

const DetermineSignIn: FC = () => {
  const { states, Create, bag } = useLoginContext()
  const initalEmail : string = (bag ? bag['email'] : '') ?? '';
  const [email, setEmail] = useState(initalEmail)
  const setEmailAndPush = (x:any) => {
    if (bag) { bag.email = x }
    setEmail(x)
  }

  const ctrl = useSimpleForm(validator)
  const { fieldProps } = ctrl
  return (
    <SimpleFormContextProvider value={ctrl}>
      <SrRegion aria-labelledby="sign-in-title" boxRef={ctrl.parentNodeRef}>
        <TextField label="Email Address" id="login-email" sx={{ mt: 2 }} autoComplete='off' fullWidth
          {...fieldProps("email", setEmailAndPush)} 
          inputProps={{ form: 'login-form' }}
          value={email}
        />
        {states.errMsg && (
          <Box sx={{ mt: 3 }}>
            <FormHelperText error>
              {states.errMsg}
            </FormHelperText>
          </Box>
        )}
        <Box sx={{ mt: 4 }} >
          <Create resource="login-preload" basePath="">
            <DetermineSignInButton email={email} />
          </Create>
        </Box>
      </SrRegion>
    </SimpleFormContextProvider>
  )
}


export default DetermineSignIn;

const DetermineSignInButton : FC<{ email:string }> = ({ email }) => {
  const determineSignIn = useSimpleSaveAction()
  const { saving: isSubmitting } = useSaveContext()
  const { dispatch } = useLoginContext()
  const { forceValidate } = useSimpleFormContext()

  const handleClick = (event:FormEvent) => {
    event.preventDefault()
    event.stopPropagation()
    const formStates = forceValidate({ email })
    if (formStates.errors['email']) { return }

    dispatch({ type: 'p1_preload', email })
    determineSignIn(email as any, {
      onSuccess: ({data}: {data:any}) => {
        const redirectUrl: {url:string} = data
        dispatch({ type: 'p1_sso', redirectUrl })
      },
      onFailure: (err:any) => {
        const errMsg = 
          (err?.response?.status === 429 || err?.body?.status === 429) 
          ? 'Too many login requests received. Please try again in a moment.' 
          : retrieveAxiosErr(err)
        dispatch({ type: 'p1_preload_error', error: errMsg })
      }
    })
  }

  const formRef = useRef<HTMLFormElement|null>(null)
  useEffect(() => {
    setTimeout(() => {
      const fstElem : HTMLInputElement|null = formRef.current?.elements[0] as any
      fstElem?.focus()
    }, 200)
  }, [])

  return (
    <form id="login-form" onSubmit={handleClick} ref={formRef}>
      <Button
        color="primary"
        disabled={isSubmitting}
        fullWidth
        size="large"
        type="submit"
        variant="contained"
      >
        Next
      </Button>
    </form>
  )
}
